import { DateRangePreset } from '../components/DateRangeSection';

export const DAY_SECONDS = 86400;

export const toUtcDayStart = (unix: number): number =>
  Math.floor(unix / DAY_SECONDS) * DAY_SECONDS;

export const startOfTodayUtc = (): number => {
  const now = new Date();
  return Math.floor(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()) / 1000,
  );
};

export function presetToRange(
  preset: DateRangePreset,
  customStart: number,
  customEnd: number,
): [number, number] {
  const today = startOfTodayUtc();
  switch (preset) {
    case '7d':
      return [today - 6 * DAY_SECONDS, today];
    case '30d':
      return [today - 29 * DAY_SECONDS, today];
    case '90d':
      return [today - 89 * DAY_SECONDS, today];
    case '180d':
      return [today - 179 * DAY_SECONDS, today];
    case 'custom':
      return [customStart, customEnd];
  }
}
